"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 10,
  orderby: "name",
  order: "asc",
  include: [39, 18]
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
function CategoryGridConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-2 gap-6 max-w-2xl mx-auto place-items-center">
        {[...Array(2)].map((_, i) => <div key={i} data-index={i} className="aspect-square w-full animate-pulse bg-muted rounded-4xl" />)}
      </div>;
  }
  if (error || terms.length === 0) {
    return <div className="flex min-h-[300px] items-center justify-center rounded-4xl border-2 border-dotted border-border/40 bg-muted/30 p-12 text-center">
        <p className="font-serif text-xl italic text-muted-foreground">Unable to load categories. Please try again later.</p>
      </div>;
  }
  const topLevelTerms = terms.sort((a: any, b: any) => {
    if (Number(a.id) === 39) return -1;
    if (Number(b.id) === 39) return 1;
    return 0;
  });
  if (topLevelTerms.length === 0) {
    return <div className="flex min-h-[300px] items-center justify-center rounded-4xl border-2 border-dotted border-border/40 bg-muted/30 p-12 text-center">
        <p className="font-serif text-xl italic text-muted-foreground">No categories available</p>
      </div>;
  }
  return <div className="grid grid-cols-2 gap-6 max-w-2xl mx-auto place-items-center">
      {topLevelTerms.map((term, i) => <Link key={term.id} to={term.link || `/term/product_cat/${term.id}`} data-index={i} className="group relative block w-full overflow-hidden bg-muted rounded-4xl border-2 border-dotted border-border/40 transition-all duration-500 hover:shadow-lg">
          <AspectRatio ratio={1}>
            {term.image_url ? <img src={term.image_url} data-wvc-srcset={`${term.image_url}-wvc-srcset`} data-wvc-sizes={`${term.image_url}-wvc-sizes`} alt={term.name} className="h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-secondary/30 text-muted-foreground">
                <span className="font-serif text-lg italic tracking-wider">
                  {term.name}
                </span>
              </div>}
            
            <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-secondary/80 via-secondary/20 to-transparent p-8 opacity-0 backdrop-blur-[2px] transition-opacity duration-700 group-hover:opacity-100">
              <h3 className="font-serif text-xl font-medium italic tracking-wide text-foreground md:text-4xl">
                <span className="block translate-y-6 transform transition-transform duration-700 group-hover:translate-y-0">
                  {term.name}
                </span>
              </h3>
            </div>
          </AspectRatio>
          <div className="p-4 text-center md:hidden">
            <span className="font-serif text-lg font-medium block text-foreground">
              {term.name}
            </span>
          </div>
        </Link>)}
    </div>;
}
export default function PremiumProductCategories() {
  return <section data-section-id="222172" id="curated-for-your-moments" className="bg-background text-foreground py-12 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="font-serif text-2xl font-light tracking-widest text-foreground md:text-5xl">
            Curated for Your Moments
          </h2>
          <div className="mx-auto mt-6 h-[1px] w-32 bg-primary/40" />
        </div>

        <EcommerceTermsProvider className="premium-categories-wrapper" wp_term_query={wp_term_query}>
          <CategoryGridConsumer />
        </EcommerceTermsProvider>
      </div>
    </section>;
}